import { Button, IconFont, Popover, SelectDropdown } from '@byecode/ui'
import type { ArgumentsType, TypeInstanceMap } from '@lighthouse/core'
import React, { useCallback, useState } from 'react'
import styled from 'styled-components'

import { innerTypeOptions } from '../../constants'

const SCxButtonContent = styled(Button)``

const SCxIcon = styled(IconFont)`
    margin-right: 6px;
`

const SCxContainer = styled.div`
    margin: 4px 0;
    display: inline-block;
`

interface AddArgButtonProps {
    onItemClick?: (value: ArgumentsType) => void
    buttonText?: string
}

export const AddArgButton: React.FC<AddArgButtonProps> = ({ buttonText = '添加', onItemClick }) => {
    const [open, setOpen] = useState(false)

    const handleItemClick = useCallback(
        (val: string) => {
            setOpen(false)
            requestAnimationFrame(() => {
                onItemClick?.(val as ArgumentsType)
            })
        },
        [onItemClick]
    )

    if (innerTypeOptions.length === 0) {
        return null
    }

    return (
        <Popover withinPortal position="bottom-start" width={300} opened={open} onChange={setOpen}>
            <Popover.Target>
                <SCxContainer>
                    <SCxButtonContent radius={100} icon={<SCxIcon type="Add" fill="var(--color-gray-500)" size={16} />}>
                        {buttonText}
                    </SCxButtonContent>
                </SCxContainer>
            </Popover.Target>
            <Popover.Dropdown>
                <SelectDropdown
                    searchable
                    styles={{ selectDropdown: { maxHeight: 300 } }}
                    options={innerTypeOptions}
                    onSelect={handleItemClick}
                />
            </Popover.Dropdown>
        </Popover>
    )
}
